import { LEAD_FACTORY_PAGE_EXPERIMENT } from '../../constants/experiments';
import { IApplicationState } from '../../types/redux';
import { isAbUseExperimentGroup } from '../../utils/experiments';

export const selectLeadFactoryPageExperimentActive = (state: IApplicationState): boolean => {
  const { abUseExperiments } = state;

  return isAbUseExperimentGroup(abUseExperiments, LEAD_FACTORY_PAGE_EXPERIMENT, 'enabled');
};
